import RegisterBugs from "components/Common/RegisterBugs"
import AddManualLogs from "pages/Timesheet/AddManualLogs"
import React, { useEffect } from "react"
import secureLocalStorage from "react-secure-storage"
import { Container, Row, Col } from "reactstrap"

const Footer = () => {

  const user = secureLocalStorage.getItem("authUser") || {}

  return (
    <React.Fragment>
      <footer className="footer">
        <Container fluid={true}>
          <Row>
            <Col md={6}>
              Copyright © {new Date().getFullYear()} All rights reserved by{" "}
              <a
                href="https://www.peacockac.com/"
                className="text-white fw-semibold"
                target="_blank"
                rel="noreferrer"
              >
                Peacock Accountants Limited.
              </a>{" "}
            </Col>
            <Col md={6}>
              <div className="text-sm-end d-none d-sm-block">
                Developed by
                {process.env.REACT_APP_API_URL?.includes(
                  "apibms.peacockac.com"
                ) ? (
                  <a
                    href="https://www.tcwitservices.com"
                    className="text-white fw-semibold"
                    target="_blank"
                    rel="noreferrer"
                  >
                    {" "}
                    The Care Workshop
                  </a>
                ) : (
                  <a
                    href="https://www.zithas.co.uk"
                    className="text-white fw-semibold"
                    target="_blank"
                    rel="noreferrer"
                  >
                    {" "}
                    Zithas Technologies
                  </a>
                )}
              </div>
            </Col>
          </Row>
        </Container>
        {/* <RegisterBugs /> */}

        {/* for employees only not for super admin */}
        {
          user.id != 1 ?
            <AddManualLogs /> : null
        }
      </footer>
    </React.Fragment>
  )
}

export default Footer
